<script setup lang="ts">
import AppIcon from "./AppIcon.vue";
import { useToast } from "@/composables/useToast";

const { toasts, dismiss } = useToast();

const ICONS: Record<string, string> = { ok: "check", bad: "alert", info: "sparkle" };
const TONES: Record<string, string> = {
  ok: "text-ok bg-ok-soft",
  bad: "text-bad bg-bad-soft",
  info: "text-accent bg-info-soft",
};
</script>

<template>
  <div class="pointer-events-none fixed inset-x-0 bottom-[calc(env(safe-area-inset-bottom,0px)+4.5rem)] z-[60] flex flex-col items-center gap-2 px-4 md:bottom-5">
    <TransitionGroup name="list">
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="pointer-events-auto flex w-full max-w-md items-center gap-3 rounded-[13px] border border-separator bg-canvas-elevated px-3.5 py-2.5 shadow-float"
      >
        <span class="grid size-6 shrink-0 place-items-center rounded-full" :class="TONES[toast.tone]">
          <AppIcon :name="ICONS[toast.tone] ?? 'sparkle'" :size="13" :stroke-width="2.2" />
        </span>
        <p class="min-w-0 flex-1 text-[13px] leading-snug wrap-anywhere text-content">{{ toast.message }}</p>
        <button
          class="shrink-0 rounded-full p-1 text-tertiary transition hover:bg-surface-hover hover:text-content"
          aria-label="Quitar el aviso"
          @click="dismiss(toast.id)"
        >
          <AppIcon name="close" :size="13" />
        </button>
      </div>
    </TransitionGroup>
  </div>
</template>
